function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 0C8.04857 0 0 7.9815 0 17.85C0 31.2375 18 51 18 51C18 51 36 31.2375 36 17.85C36 7.9815 27.9514 0 18 0ZM18 24.225C16.295 24.225 14.6599 23.5533 13.4543 22.3578C12.2487 21.1623 11.5714 19.5408 11.5714 17.85C11.5714 16.1592 12.2487 14.5377 13.4543 13.3422C14.6599 12.1466 16.295 11.475 18 11.475C19.705 11.475 21.3401 12.1466 22.5457 13.3422C23.7513 14.5377 24.4286 16.1592 24.4286 17.85C24.4286 19.5408 23.7513 21.1623 22.5457 22.3578C21.3401 23.5533 19.705 24.225 18 24.225Z",
  fill: "#F7A512"
});

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.574e7c40.svg";
export { ForwardRef as ReactComponent };